import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_cycle_audit_trail_RowClass} from '../../../dbschema';

export class ClaimCycleAuditTrailContainer extends BaseContainerModel {
  bl_aat_claim_cycle_audit_trail: bl_aat_claim_cycle_audit_trail_RowClass = new bl_aat_claim_cycle_audit_trail_RowClass();
}
